<template>
  <div>
    <div class="containar">
      <div class="contents-block">
        <div class="preview-area">
          <div class="preview-header">
            <h3>プレビュー</h3>
          </div>
          <div class="voice-container">
            <ul class="voice-states" v-bind:class="[avatarStyle]">
              <li class="voice-state"><img class="avatar color1 speaking" :src="imgPath" v-bind:class="[radiusStyle, animeStyle]">
                <div class="user">
                  <span class="name " v-bind:style="{background: colors.hex8}" v-bind:class="nameStyle">User1</span>
                </div>
              </li>
              <li class="voice-state" v-bind:class="avatarStyle"><img class="avatar color2" :src="imgPath" v-bind:class="[radiusStyle, blightStyle]">
                <div class="user">
                  <span class="name" v-bind:style="{background: colors.hex8}" v-bind:class="nameStyle">User2</span>
                </div>
              </li>
              <li class="voice-state" v-bind:class="avatarStyle"><img class="avatar color3" :src="imgPath" v-bind:class="[radiusStyle, blightStyle]">
                <div class="user">
                  <span class="name" v-bind:style="{background: colors.hex8}" v-bind:class="nameStyle">User3</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="set">
          <h3>アイコンの大きさ</h3>
          <div class="toggle-group">
            <label class="toggle-option">
              <input type="radio" value="dafaultavatar" v-model="avatarstyle" />
              <span class="toggle-label">デフォルト</span>
            </label>
            <label class="toggle-option">
              <input type="radio" value="bigavatar" v-model="avatarstyle" />
              <span class="toggle-label">でかい</span>
            </label>
            <label class="toggle-option">
              <input type="radio" value="sobigavatar" v-model="avatarstyle" />
              <span class="toggle-label">でっかい</span>
            </label>
          </div>
          
          <h3>アイコンの形</h3>
          <div class="toggle-group">
            <label class="toggle-option">
              <input type="radio" value="circle" v-model="radiusstyle" />
              <span class="toggle-label">まる</span>
            </label>
            <label class="toggle-option">
              <input type="radio" value="radius" v-model="radiusstyle" />
              <span class="toggle-label">角まる</span>
            </label>
            <label class="toggle-option">
              <input type="radio" value="square" v-model="radiusstyle" />
              <span class="toggle-label">四角</span>
            </label>
          </div>
          
          <h3>名前の形</h3>
          <div class="toggle-group">
            <label class="toggle-option">
              <input type="radio" value="defaultname" v-model="namestyle" />
              <span class="toggle-label">デフォルト</span>
            </label>
            <label class="toggle-option">
              <input type="radio" value="circlename" v-model="namestyle" />
              <span class="toggle-label">角まる</span>
            </label>
          </div>
          
          <h3>話している人のアニメーション</h3>
          <div class="toggle-group">
            <label class="toggle-option">
              <input type="radio" value="defaulanime" v-model="animestyle" />
              <span class="toggle-label">デフォルト</span>
            </label>
            <label class="toggle-option">
              <input type="radio" value="fuwafuwa" v-model="animestyle" />
              <span class="toggle-label">ふわふわ</span>
            </label>
            <label class="toggle-option">
              <input type="radio" value="pyoko" v-model="animestyle" />
              <span class="toggle-label">ぴょこぴょこ</span>
            </label>
          </div>
          
          <h3>名前のカラー選択</h3>
          <div class="color-picker-wrapper">
            <chrome-picker :value="colors" v-model="colors"></chrome-picker>
          </div>
          
          <h3>コピペ用CSS</h3>
          <div class="url-description">
            <p>DiscordオーバレイのカスタムCSSです。</p>
            <p><a href="https://streamkit.discord.com/overlay" target="_blank" rel="noopener noreferrer">streamkit</a>でDiscordのボイスチャンネルのURLを取得→OBSでブラウザソースを追加し、URLを貼り付け→下記CSSをカスタムCSS欄にコピペ</p>
            <p>縦ならびにしたいときは、ブラウザソースの幅を小さくします。200とか。</p>
            <p><a href="https://www.ruri.info/?p=188" target="_blank" rel="noopener noreferrer">さらに詳しい使い方はこちら</a></p>
          </div>
          <div class="url-container">
            <textarea id="target" readonly class="url-input textarea" v-model="resultCSS" />
            <button @click="copy" class="url-copy-btn">
              <span>コピー</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {Chrome} from 'vue-color'
export default {
  name: "app",
  components: {
    'chrome-picker': Chrome,
   },
  data() {
    return {
      imgPath: require('@/assets/discord-icon.png'),
      radiusstyle: 'circle',
      animestyle: 'defaulanime',
      avatarstyle:'dafaultavatar',
      namestyle:'defaultname',
      colors: {
          hex: '#000000',
          hex8: '#000000FF',
          hsl: { h: 150, s: 0, l: 0, a: 1 },
          rgba: { r: 0, g: 0, b: 0, a: 1 },
          a: 1
      },
      importcss:':root {\n',
      namecolor:'--name-bg-color:',
      radiuscss : '--icon-radius:50%;\n',
      avatarcss:'--avatar-size:56px;\n',
      namecss:'--name-radius:3px;\n',
      screencss:'ul li{margin-top:30px;display: block;}',
      anime:'',
      nonanimeblight:'',
    };
  },
  methods: {
    copy () {
      if(navigator.clipboard){
        navigator.clipboard.writeText("[class*='Voice_voiceStates__']{list-style-type:none;padding-left:15px;display:flex;flex-wrap:wrap;}[class*='Voice_voiceState__']{height:var(--avatar-size);}[class*='Voice_avatar__']{width:var(--avatar-size);height:var(--avatar-size);border-radius:var(--icon-radius);filter:brightness(var(--staging-brightness));margin-bottom: 3px;}[class*='Voice_avatarSpeaking__']{animation:var(--speaking-anime);filter:brightness(var(--speaking-brightness))!important;border-color:var(--trans)!important;}@keyframes fuwafuwa{0%{transform:translate(0,0)rotate(-5deg);}50%{transform:translate(0,-5px)rotate(0deg);}100%{transform:translate(0,0)rotate(5deg);}}@keyframes pyoko{0%{transform:translate(0,0)rotate(0deg);}50%{transform:translate(0,-10px)rotate(0deg);}100%{transform:translate(0,0)rotate(0deg);}}[class*='Voice_name__']{text-align:center;width:var(--avatar-size);background-color:var(--name-bg-color)!important;opacity:var(--name-opacity)!important;font-size:17px;border-radius:var(--name-radius);padding:2px 0px!important;margin-right:2px;margin-left:4px;box-sizing:border-box;overflow:hidden;display:block;}[class*='Voice_name__']{text-overflow:ellipsis;overflow:hidden;white-space:nowrap;}\n" +this.importcss +this.avatarcss + this.namecolor + this.colors.hex8 + ";\n" + this.radiuscss + this.namecss + this.anime + this.nonanimeblight + "}\n" + this.screencss)
        console.log('コピー完了')
        return true
      } else {
        return false
      }
    },

    setRadiusCss: function(){
        switch(this.radiusstyle){
            case 'radius':
                this.radiuscss = '--icon-radius:38%;\n'
                break;
            case 'circle':
                this.radiuscss = '--icon-radius:50%;\n'
                break;
            case 'square':
                this.radiuscss = '--icon-radius:0%;\n'
                break;
        }
    },
    setAvatarCss: function(){
        switch(this.avatarstyle){
            case 'dafaultavatar':
                this.avatarcss = '--avatar-size:56px;\n'
                break;
            case 'bigavatar':
                this.avatarcss = '--avatar-size:72px;\n'
                break;
            case 'sobigavatar':
                this.avatarcss = '--avatar-size:96px;\n'
                break;
        }
    },
    setNameCss: function(){
      switch(this.namestyle){
            case 'defaultname':
                this.namecss = '--name-radius:3px;\n'
                break;
            case 'circlename':
                this.namecss = '--name-radius:18px;\n'
                break;
        }
    },
    setAnimeCss: function(){
        switch(this.animestyle){
            case 'defaulanime':
                this.anime = ''
                this.nonanimeblight= ''
                break;
            case 'fuwafuwa':
                this.anime = '--speaking-anime:fuwafuwa 300ms infinite linear alternate;\n--speaking-brightness:100%;\n--trans:transparent;\n'
                this.nonanimeblight= '--staging-brightness:70%;\n'
                break;
            case 'pyoko':
                this.anime = '--speaking-anime:pyoko 300ms infinite linear alternate;\n--speaking-brightness:100%;\n--trans:transparent;\n'
                this.nonanimeblight= '--staging-brightness:70%;\n'
                break;
        }
    },
  },
  watch:{
    radiusstyle:function(){
        this.setRadiusCss()
    },
    avatarstyle:function(){
        this.setAvatarCss()
    },
    namestyle:function(){
        this.setNameCss()
    },
    animestyle:function(){
        this.setAnimeCss()
    },
  },
  computed: {
    resultCSS(){
        return "[class*='Voice_voiceStates__']{list-style-type:none;padding-left:15px;display:flex;flex-wrap:wrap;}[class*='Voice_voiceState__']{height:var(--avatar-size);}[class*='Voice_avatar__']{width:var(--avatar-size);height:var(--avatar-size);border-radius:var(--icon-radius);filter:brightness(var(--staging-brightness));margin-bottom: 3px;}[class*='Voice_avatarSpeaking__']{animation:var(--speaking-anime);filter:brightness(var(--speaking-brightness))!important;border-color:var(--trans)!important;}@keyframes fuwafuwa{0%{transform:translate(0,0)rotate(-5deg);}50%{transform:translate(0,-5px)rotate(0deg);}100%{transform:translate(0,0)rotate(5deg);}}@keyframes pyoko{0%{transform:translate(0,0)rotate(0deg);}50%{transform:translate(0,-10px)rotate(0deg);}100%{transform:translate(0,0)rotate(0deg);}}[class*='Voice_name__']{text-align:center;width:var(--avatar-size);background-color:var(--name-bg-color)!important;opacity:var(--name-opacity)!important;font-size:12px!important;border-radius:var(--name-radius);padding:2px 0px!important;margin-right:2px;margin-left:4px;box-sizing:border-box;overflow:hidden;display:block;}[class*='Voice_name__']{text-overflow:ellipsis;overflow:hidden;white-space:nowrap;}\n" + this.importcss + this.avatarcss + this.namecolor + this.colors.hex8 + ";\n" + this.radiuscss + this.namecss + this.anime + this.nonanimeblight + "}\n"  + this.screencss;
    },
    radiusStyle: function() {
      if (this.radiusstyle === 'radius') {
        return 'avatar-radius';
      }
      else if (this.radiusstyle === 'circle') {
        return 'avatar-circle';
      }
      else {
        return 'avatar-square';
      }
    },
    avatarStyle: function() {
      if (this.avatarstyle === 'dafaultavatar') {
        return 'avatar-size1';
      }
      else if (this.avatarstyle === 'bigavatar') {
        return 'avatar-size2';
      }
      else {
        return 'avatar-size3';
      }
    },
    nameStyle: function(){
      if (this.namestyle === 'defaultname') {
        return 'name-radius1';
      }
      else if (this.namestyle === 'circlename') {
        return 'name-radius2';
      }
      else {
        return '';
      }
    },
    animeStyle: function() {
      if (this.animestyle === 'pyoko') {
        return 'pyoko';
      }
      else if (this.animestyle === 'fuwafuwa') {
        return 'fuwafuwa';
      }
      else {
        return '';
      }
    },
    blightStyle: function() {
      if (this.animestyle === 'defaulanime') {
        return '';
      }
      else {
        return 'brightness';
      }
    },
  },
};
</script>
<style scoped>
p {
  margin: 0;
  padding: 0;
  font-size: 14px;
}

h3{
  font-size: 14px;
  margin-top: 24px;
  margin-bottom: 0;
}

.containar{
  margin: 0 auto;
  width: 100%;
}

/* Layout Styles */
.contents-block{
  display: -webkit-flex;
	display: flex;
	-webkit-flex-wrap: nowrap;
	flex-wrap: nowrap;
	-webkit-justify-content: space-around;
	justify-content: space-around;
	-webkit-align-items: flex-start;
	align-items: flex-start;
  margin: 24px auto;
  gap: 24px;
}

@media screen and (max-width: 767px) {
  .contents-block{
    display: block;
    margin: 0 auto;
  }

  .set{
    margin-top:24px;
    margin-left: 0;
  }
}

.set{
  flex: 1;
  max-width: 420px;
  padding: 8px 12px 24px 12px;
  background-color: #FFFEF9;
  border-radius: 10px;
}

/* プレビューエリア */
.preview-area{
  flex: 1;
  max-width: 420px;
  min-width: 320px;
}

.preview-header{
  padding: 2px 12px;
  margin-bottom: 16px;
}

.voice-container{
  margin-bottom: 48px;
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    color: #fff;
}

.voice-states{
    list-style-type: none;
    padding-left: 15px;
    display: flex;
  margin-bottom: 3px;
}

.voice-container .voice-states .voice-state {
  height: var(--avatar-size);
  margin-bottom: 5px;
}

ul {
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
}

li {
    display: list-item;
    text-align: -webkit-match-parent;
    vertical-align: middle;
}

.voice-container .voice-states .voice-state .avatar {
    border: 3px solid transparent;
    float: left;
    margin-right: 14px;
    margin-bottom:5px;
    object-fit: scale-down;
    padding: 5px;
    box-sizing:border-box;
    height: var(--avatar-size);
    width: var(--avatar-size);
}

.speaking{
  border-color: #43b581 !important;
}

.fuwafuwa {
  animation:fuwafuwa 300ms infinite linear alternate;
  filter: brightness(100%);
  border-color: transparent!important;
}

@keyframes fuwafuwa {
  0% {transform:translate(0, 0) rotate(-5deg);}
  50% {transform:translate(0, -5px) rotate(0deg);}
  100% {transform:translate(0, 0)rotate(5deg);}
}

.pyoko {
  animation:pyoko 300ms infinite linear alternate;
  filter: brightness(100%);
  border-color: transparent!important;
}

@keyframes pyoko {
    0% {transform:translate(0, 0) rotate(0deg);}
    50% {transform:translate(0, -10px) rotate(0deg);}
    100% {transform:translate(0, 0)rotate(0deg);}
}

.brightness{
  filter: brightness(70%);
}

.color1{
  background-color: blue;
}

.color2{
  background-color: lightcoral;
}

.color3{
  background-color: lightgreen;
}

.avatar-radius{
  border-radius: 38%;
}

.avatar-circle{
  border-radius: 50%;
}

.avatar-square{
  border-radius: 0%;
}

.avatar-size1{
  --avatar-size:56px;
  --ff:56px;
}

.avatar-size2{
   --avatar-size:72px;
   --ff:72px;
}

.avatar-size3{
   --avatar-size:96px;
}

.name-radius1{
  --name-radius:3px;
}

.name-radius2{
  --name-radius:18px;
}

.voice-container .voice-states .voice-state .user {
    padding-top: calc(var(--avatar-size)/3);
}

.voice-container .voice-states .voice-state .user .name {
    text-align: center;
    max-width: var(--avatar-size);
    background-color: #1e2124;
    color:white;
    font-size: 12px;
    padding: 4px 6px;

    box-sizing: border-box;
    overflow: hidden;
    display: block;
}

.name{
  border-radius:var(--name-radius);
}

.select-gradation{
  text-align: center;
  background-color: aliceblue;
  width: -moz-fit-content;
  width: fit-content;
  margin: 0 auto;
  padding: 24px 24px 12px 24px;
  line-height: 1;
  border-radius: 10px;
  margin-right: 12px;
}

.select-font{
    font-size: 24px;
  text-align: center;
  background-color: aliceblue;
  width: -moz-fit-content;
  width: fit-content;
  padding: 12px;
  line-height: 1;
  border-radius: 10px;
  margin-right: 12px;
}

.date-off{
  display:none;
}

/* Toggle Group (Radio Buttons) */
.toggle-group {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
}

.toggle-option {
  position: relative;
  cursor: pointer;
}

.toggle-option input[type="radio"] {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.toggle-label {
  display: inline-block;
  padding: 8px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  color: #64748b;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s ease;
  min-width: 60px;
  text-align: center;
}

.toggle-option input[type="radio"]:checked + .toggle-label {
  background: #0f172a;
  color: #ffffff;
  border-color: #0f172a;
}

.toggle-option:hover .toggle-label {
  border-color: #cbd5e1;
}

/* Color Picker */
.color-picker-wrapper {
  margin-top: 12px;
}

.color-picker-wrapper .vc-chrome {
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 0 0 1px #e2e8f0;
  font-family: system-ui, -apple-system, sans-serif;
}

.color-picker-wrapper .vc-saturation-wrap {
  border-radius: 6px 6px 0 0;
}

.color-picker-wrapper .vc-chrome-controls {
  padding: 12px;
}

.color-picker-wrapper .vc-hue,
.color-picker-wrapper .vc-alpha {
  border-radius: 4px;
  height: 12px;
}

.color-picker-wrapper .vc-chrome-fields-wrap {
  padding-top: 12px;
}

.color-picker-wrapper .vc-input__input {
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  padding: 6px 8px;
  font-size: 12px;
}

.color-picker-wrapper .vc-input__input:focus {
  border-color: #0f172a;
  outline: none;
  box-shadow: 0 0 0 1px rgba(15, 23, 42, 0.2);
}

.color-picker-wrapper .vc-input__label {
  font-size: 11px;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.025em;
}

.color-picker-wrapper .vc-chrome-color-wrap {
  border-radius: 4px;
}

.color-picker-wrapper .vc-chrome-active-color {
  border-radius: 4px;
}

.color-picker-wrapper .vc-hue-pointer,
.color-picker-wrapper .vc-alpha-pointer {
  width: 16px;
  height: 16px;
}

.color-picker-wrapper .vc-hue-picker,
.color-picker-wrapper .vc-alpha-picker {
  background: #ffffff;
  border: 2px solid #ffffff;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.color-picker-wrapper .vc-saturation-pointer {
  width: 14px;
  height: 14px;
}

.color-picker-wrapper .vc-saturation-circle {
  border: 2px solid #ffffff;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

/* URL Section */
.url-description {
  margin: 12px 0 16px 0;
}

.url-description p {
  font-size: 13px;
  color: #718096;
  margin: 0 0 6px 0;
  line-height: 1.5;
}

.url-description a {
  color: #0f172a;
  text-decoration: underline;
}

.url-description a:hover {
  color: #1e293b;
}

.url-container {
  display: flex;
  gap: 8px;
  align-items: stretch;
  margin-bottom: 16px;
}

.url-input {
  flex: 1;
  height: 2.4em;
  padding: 0 12px;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
  font-size: 12px;
  background: #f8fafc;
  color: #4a5568;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  line-height: 1.4;
  resize: vertical;
}

.url-input.textarea {
  height: 80px;
  padding: 12px;
  resize: vertical;
}

.url-input:focus {
  outline: none;
  box-shadow: 0 0 0 2px #0f172a;
}

.url-copy-btn {
  padding: 0 20px;
  height: 2.4em;
  background: #0f172a;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
}

.url-copy-btn:hover {
  background: #0f172a;
  transform: translateY(-1px);
}

.url-copy-btn:active {
  transform: translateY(0);
}

</style>